// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_BLQbq{display:flex}", ""]);
// Exports
exports.locals = {
	"container": "container_BLQbq"
};
module.exports = exports;
